import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ScrollingListService } from 'src/app/ajs-upgraded-providers';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { ScrollingList } from 'src/app/components/scrolling-list/legacy/page-with-list.component';
import { ReviewService } from 'src/app/template-editor/services/review.service';

@Component({
  selector: 'app-review-request',
  templateUrl: './review-request.component.html',
  standalone: false,
})
export class ReviewRequestComponent {
  filterConfig = {
    placeholder: 'Search Users',
  };
  search = {
    companyId: this.companyStateService.getSelectedCompanyId(),
    sortBy: 'username',
    reverse: false,
    name: 'Users',
    onListUpdate: () => {
      this.changeDetectorRef.detectChanges();
    },
  };

  users: ScrollingList<any> = this.ScrollingListService(
    this.reviewService.listReviewers.bind(this.reviewService),
    this.search,
  );

  private changeDetectorRef = inject(ChangeDetectorRef);
  private selectedUsers = new Set<string>();
  protected commentFormControl = '';

  constructor(
    dialogRef: MatDialogRef<ReviewRequestComponent>,
    private companyStateService: CompanyStateService,
    private ScrollingListService: ScrollingListService,
    private reviewService: ReviewService,
  ) {}

  toggleUser(userId: string) {
    if (this.selectedUsers.has(userId)) {
      this.selectedUsers.delete(userId);
    } else {
      this.selectedUsers.add(userId);
    }
  }

  userSelected(userId: string) {
    return this.selectedUsers.has(userId);
  }

  get result() {
    return {
      reviewerIds: Array.from(this.selectedUsers).map((id) => id),
      notes: this.commentFormControl,
    };
  }
}
